import React from 'react';
import { useParams } from 'react-router-dom';
import GroupChat from './GroupChat';

export default function GroupChatWrapper() {
  const { groupId } = useParams();
  const currentUser = JSON.parse(localStorage.getItem('currentUser'));

  return <GroupChat groupId={groupId} currentUser={currentUser} />;
}
